const mainPreview = {
  mainPreview: {
    search: "Найти",
  },
};

export { mainPreview };
